import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function SeriesListItem( { index, item, id } ){
  const [data, setData] = useState([]);
  const streak = Math.floor((new Date() - new Date("2023-08-01")) / (1000 * 60 * 60 * 24)); //for daily cc

  let name = item.properties.Name.title[0].plain_text;
  let thumbnail = item.icon?.file.url;
  let summary = item.properties?.Summary.rich_text?.[0]?.plain_text;

  //FETCH BLOGS
  const fetchData = async ( id ) => {
    try {
      const response = await fetch(`https://imajin.dev/api/query-a-database-blogs-with-series`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ series_id: id })
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();
      setData(result); //show only 3 blogs
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  
  useEffect(() => {
    fetchData(id);
  }, []);

  return(
    <div style = { { paddingBottom : "0px" } }>
      <Link to = {`/series/${id}`}
        style = { { textDecoration : "none" } }
        className="a"
      >
        <div className = "seriesList">
          {/* <div style = { { backgroundColor : "var(--black4)",
            width : "56px", height : "100px", overflow : "hidden" } }>
            <img style = { { width : "101px", height : "101px", transform : "scale(1.5)" } } src = { thumbnail }/>
          </div> */}

          <div style = { { flex : 1, padding : "16px", display : "flex", flexDirection : "column", gap : "0px", justifyContent : "center" } }>
            <h1 className = "heading" style = { { lineHeight : "120%" } }>{ name }</h1> 
            <p style = { { fontSize : "var(--font-size-tiny)", lineHeight : "120%" } }>{ summary } { name === "Daily Creative Coding" ? `${streak} streaks, as of today.` : ""}</p>
          </div>

          {/* <h1 className = "heading" style = { { fontSize : "100px", fontWeight : "300", lineHeight : "100%" } }>{ index }</h1> */}
        </div>
        </Link>


        <div style = { { marginLeft : "16px" } }>
          <p style = { { padding : "8px 0px" } } className = "meta2">{ data.length } Blogs</p>

          <div style = { { display : "flex", flexDirection : "column", gap : "4px" } }>
          { data.slice(0,3).map( ( item, i ) => (
            <Link  key = { i } to = {`/blog/${item.id}`} style = { { textDecoration : "none" } }>
              <div className = "blogListItem" style = { { display : "flex", flexDirection : "row", gap : "28px", paddingRight : "16px" } }>
                <p style = { { flex : 1, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" } }>{ item.properties.Name?.title[0]?.plain_text }</p>
                <p style = { { color : "var(--black40)", fontSize : "var(--font-size-tiny)" } }>{ item.properties.Created_date.formula.string.slice(0,7) }</p>
              </div>
            </Link>
          ))}
          </div>
        </div>

    </div>
  )
}